

/**
 * @fileOverview ListToPushDown module definition
 * Last Modified: 6/11/2014
 */


(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('views/ListToPushDown',['require','jquery','lib/Util','GlobalEventDispatcher','GlobalResizeListener','controllers/ResponsiveAccordion'],function(require) {
        var $ = require('jquery');
        var Util = require('lib/Util');
        var GlobalEventDispatcher = require('GlobalEventDispatcher');
        var GlobalResizeListener = require('GlobalResizeListener');
        var ResponsiveAccordion = require('controllers/ResponsiveAccordion');
        $debug('ListToPushDown loaded... use ?debug=listToPushDown for messages');

        /**
         * This takes a list of links and converts it to a select element on the smallest view. It converts
         * back on transition to a larger view.
         *
         * @class ListToPushDown
         * @param {jQuery} $element A reference to the containing DOM element
         * @constructor
         */
        var ListToPushDown = function ($element) {
            /**
             * A reference to the containing DOM element
             *
             * @default null
             * @property $element
             * @type {jQuery}
             * @public
             */
            this.$element = $($element);

            /**
             * A reference to the global event dispatcher, provided by the application.
             *
             * @property eventDispatcher
             * @type {}
             * @private
             */
            this.eventDispatcher = GlobalEventDispatcher.getEventDispatcher(); // event dispatcher that will call the event, provided by the application

            /**
             * A reference to the global resize listener.
             *
             * @property getResizeListener
             * @type {}
             * @private
             */
            this.globalResizeListener = GlobalResizeListener.getResizeListener();

            /**
             * Tracks whether component is enabled.
             *
             * @default false
             * @property isEnabled
             * @type {bool}
             * @public
             */
            this.isEnabled = false;

            this.init();
        };

        /**
         * Initializes the UI Component View
         * Runs a single setupHandlers call, followed by createChildren and layout
         * Exits early if it is already initialized
         *
         * @method init
         * @returns {ListToPushDown}
         * @private
         */
        ListToPushDown.prototype.init = function() {
            this.setOptions()
                .setupHandlers()
                .createChildren()
                .layout();

            return this;
        };


        /**
         * This sets the options via data-options in the html markup. If
         * the options aren't set it goes to the defaults.
         *
         * @method setOptions
         * @returns {ExpandContentView}
         * @private
         */
        ListToPushDown.prototype.setOptions = function () {
            var options = this.$element.data().options;
            var defaults = {
                capitalizeHeading : true
            };
            this.settings = $.extend({}, defaults, options);
            $debug('     Block Options ', 'listToPushDown');
            $debug('          HTML data-options Settings: ' + $printObj(options),'listToPushDown');
            $debug('          Default Settings: ' + $printObj(defaults),'listToPushDown');
            $debug('          Combined Settings: ' + $printObj(this.settings),'listToPushDown');

            return this;
        };

        /**
         * Binds the scope of any handler functions
         * Should only be run on initialization of the view
         *
         * This creates event handlers and binds the scope
         * of the JS.
         *
         * @method setupHandlers
         * @returns {ListToPushDown}
         * @private
         */
        ListToPushDown.prototype.setupHandlers = function() {
            // Bind event handlers scope here
            this.eventDispatcher.subscribe(GlobalEventDispatcher.EVENTS.CONTEXT_CHANGE, this.layout.bind(this));

            this.onChangeHandler = this.onChange.bind(this);

            return this;
        };

        /**
         * Create any child objects or references to DOM elements
         * Should only be run on initialization of the view
         *
         * @method createChildren
         * @returns {ListToPushDown}
         * @private
         */
        ListToPushDown.prototype.createChildren = function() {
            this.$headingEl = this.$element.find('.MMM--sideBox-hd, .js-pushDownHeading');
            this.$secondaryBlocks= this.$element.find('.MMM--sideBox-LSN-List, .js-pushDownList');
            this.$menuList = this.$element.find('.js-listToPushDownWrapper');

            $debug('Found ' + this.$headingEl.length + ' headings', 'listToPushDown');
            $debug('Found ' + this.$secondaryBlocks.length + ' secondary blocks', 'listToPushDown');
            $debug('Found ' + this.$menuList.length + ' Menu Lists... (should be 1!)', 'listToPushDown');

            this.$pushDown = null;

            return this;
        };

        /**
         * Remove any child objects or references to DOM elements
         *
         * @method removeChildren
         * @returns {ListToPushDown}
         * @public
         */
        ListToPushDown.prototype.removeChildren = function() {

            return this;
        };

        /**
         * Performs measurements and applys any positioning style logic
         * Should be run anytime the parent layout changes
         *
         * @method layout
         * @returns {ListToPushDown}
         * @public
         */
        ListToPushDown.prototype.layout = function() {
            var self = this;
            var context = this.globalResizeListener.getCurrentContext();
            var finalHTML = '';
            $debug('Layout Change Fired ' + context, 'listToPushDown');
            $debug('self.$pushDown= ' + self.$pushDown, 'listToPushDown');

            if (context === 'smallContext') {
                if(self.$pushDown === null) {
                
                    var randomNumber = Math.floor((Math.random() * 100000) + 1);
                    var buttonHeading = self.$headingEl.text(); //get heading text
                    if (self.settings.capitalizeHeading === true){
                        buttonHeading = buttonHeading.toUpperCase();    //capatilize if needed
                    }
                    
                    //output pushdown trigger
                    finalHTML = '<div id="js-pushDown' + randomNumber + '" class="js-pushDownContainer">';
                    finalHTML += '<a href="#pushdownContent' + randomNumber + '" class="MMM--btn mix-MMM--btn_fullWidth MMM--btn_noAnimation MMM--basicLink MMM--sideBar-LSN-button js-contentToggle-trigger_lsn">';
                    finalHTML += '<i class="MMM--icn MMM--icn_twistyAction mix-MMM--icn_rightSpace"></i>' + buttonHeading + '</a>';
                    finalHTML += '<div id="pushdownContent' + randomNumber + '" class="js-contentToggle-target MMM--contentToggle-target ">';
                    finalHTML += '<div><div class="MMM--pageSection MMM--pageSection_noDividers">';
                    finalHTML += '<ul class="MMM--accordionList MMM--accordionList_twisty" id="js-pushDownMainUL_' + randomNumber + '"></ul>';
                    finalHTML += '</div></div></div></div>';
                    self.$element.append(finalHTML);

                    self.$secondaryBlocks.each(function(i,e){
                        var hasChildren = false;
                        var secondaryHeading = $(e).find('.MMM--accordionList-label, .js-pushDownLabel');
                        var secondaryHeadingText = secondaryHeading.text();
                        var htmlFrag = '';
                        if ($(e).children('ul').length !== 0){
                            hasChildren = true;
                        }
                        if (hasChildren === true){
                            htmlFrag = '<li class="secondaryPushDownSection" id="js-pushDownSecondaryLI_' + randomNumber + i + '">';
                            htmlFrag += '<a class="MMM--accordionList-trigger MMM--sideBar-LSN-label js-contentToggle-trigger_lsn_twisty" href="#tertiary' + i + '">';
                            htmlFrag += '<i class="MMM--icn MMM--icn_plus mix-MMM--icn_md MMM--accordionList-trigger-icn"></i>';
                            htmlFrag += '<span class="MMM--accordionList-trigger-label">' + secondaryHeadingText + '</span></a></li>';
                            $('#js-pushDownMainUL_' + randomNumber).append(htmlFrag);
                        }
                        else {
                            //no children
                            htmlFrag = '<li class="secondaryPushDownSection" id="js-pushDownSecondaryLI_' + randomNumber + i + '"></li>';
                            $('#js-pushDownMainUL_' + randomNumber).append(htmlFrag);
                            $(secondaryHeading).clone(true).addClass('MMM--accordionList-trigger').appendTo('#js-pushDownSecondaryLI_' + randomNumber + i);
                        }
                        if (hasChildren === true){
                            $('#js-pushDownSecondaryLI_' + randomNumber + i).append('<div id="tertiary' + i + '" class="MMM--accordionList-infoContainer js-contentToggle-target MMM--contentToggle-target"><ul class="MMM--vList">');
                            $(e).find('ul li').each(function(j,f){
                                $('#tertiary' + i + ' ul.MMM--vList').append($(f).clone(true));
                            });

                            $('#js-pushDownSecondaryLI_' + randomNumber + i).append('</ul></div>');
                        }

                    });
                    
                    self.$pushDown = $('#js-pushDown' + randomNumber);  //set pushdown ID
                    $debug('   PushDown ID is: #js-pushDown' + randomNumber, 'listToPushDown');

                    $debug('   Found ' + self.$pushDown.length + ' pushdowns...', 'listToPushDown');

                    //create twistie handler
                    self.accordionElement = new ResponsiveAccordion({selector: '.js-contentToggle-trigger_lsn', alwaysActive: true, jumpsToTop: false, isTwisty: true, application: self});

                    self.secondaryAccordion = new ResponsiveAccordion({selector: '.js-contentToggle-trigger_lsn_twisty', alwaysActive: true, jumpsToTop: false, isTwisty: true, application: self});

                    self.enable();   //set enabled to true
                    
                    self.$menuList.hide();          //hide original container

                    return self.$pushDown;
                }
            }
            else {
                //not small context
                $debug('Enabled? ' + self.isEnabled, 'listToPushDown');
                if(self.isEnabled) {
                    self.disable();             //set disabled to true
                    self.$pushDown.remove();  //remove twistie section
                    self.$pushDown = null;
                }

                self.$menuList.show();          //show original container, if not already
            }

            return this;
        };

        /**
         * Enables the component
         * Performs any event binding to handlers
         * Exits early if it is already enabled
         *
         * @method enable
         * @returns {ListToPushDown}
         * @public
         */
        ListToPushDown.prototype.enable = function() {
            if (this.isEnabled) {
                return this;
            }
            this.isEnabled = true;
            //this.$pushDown.on('change', this.onChangeHandler);

            return this;
        };

        /**
         * Disables the component
         * Tears down any event binding to handlers
         * Exits early if it is already disabled
         *
         * @method disable
         * @returns {ListToPushDown}
         * @public
         */
        ListToPushDown.prototype.disable = function() {
            if (!this.isEnabled) {
                return this;
            }
            this.isEnabled = false;
          

            return this;
        };

        /**
         * Destroys the component
         * Tears down any events, handlers, elements
         * Should be called when the object should be left unused
         *
         * @method destroy
         * @returns {ListToPushDown}
         * @public
         */
        ListToPushDown.prototype.destroy = function() {
            this.disable()
                .removeChildren();
            return this;
        };

        //////////////////////////////////////////////////////////////////////////////////
        // EVENT HANDLERS
        //
        // Place events here, use event handlers to access it
        //////////////////////////////////////////////////////////////////////////////////

        /**
         * onChange handler
         * When the select is changed it fires an alert of the selected value.
         *
         * @method onChange
         * @private
         */
        ListToPushDown.prototype.onChange = function() {
            
           
        };

        return ListToPushDown;
    });

}(MMMRequire));

